
define('modules/application/wizard/classes/intrusionDetectionMainControlUnit',["app",

// Libs
"backbone",

//Classes
"./mainControlUnit"],

function(app, Backbone, mainControlUnit) {

  var intrusionDetectionMainControlUnit = _.extend({}, mainControlUnit, {

    Views: {
      titleBar: mainControlUnit.Views.titleBar,
      content: mainControlUnit.Views.content
    },

    Model: mainControlUnit.Model.extend({
      defaults: _.extend(_.extend({}, mainControlUnit.Model.prototype.defaults), {
        infoQuote              : "IDS_WGENTT_000014"
      })
    })

  });

  // Required, return the module for AMD compliance
  return intrusionDetectionMainControlUnit;

});